export var VelavuInvoiceStatus;
(function (VelavuInvoiceStatus) {
    VelavuInvoiceStatus["Draft"] = "draft";
    VelavuInvoiceStatus["Open"] = "open";
    VelavuInvoiceStatus["Paid"] = "paid";
    VelavuInvoiceStatus["Void"] = "void";
    VelavuInvoiceStatus["Uncollectible"] = "uncollectible";
})(VelavuInvoiceStatus || (VelavuInvoiceStatus = {}));
//# sourceMappingURL=invoice.js.map